import { configureRequestParams, getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets the list of entities.
 */
export const getEntities = async (sorting, pagination) => {
  const params = configureRequestParams(sorting, pagination)
  try {
    return await axios.get(`/entities/${params}`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Add a new entity.
 * @param {object} payload - The entity data to be added.
 */
export const addEntity = async (payload) => {
  try {
    return await axios.post('/entities/', payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Get all entities with no pagination for RescueX Admins.
 */
export const getAllEntities = async () => {
  try {
    return await axios.get('/entities/all_entities/')
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Get a single entity by ID.
 * @param {string} id - The entity ID.
 */
export const getEntity = async (id) => {
  try {
    return await axios.get(`/entities/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Update an entity.
 * @param {object} payload - The entity data to be updated.
 */
export const updateEntity = async (payload) => {
  try {
    return await axios.patch(`/entities/${payload.id}/`, payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Deletes an entity.
 * @param {string} id - The entity id to be deleted.
 */
export const deleteEntity = async (id) => {
  try {
    return await axios.delete(`/entities/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
